
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
@Options({
  props: ["ranks"]
})
export default class PlayerRankings extends Base {
  ranks!: any;
  rank(index: any) {
    return index + 1;
  }
}
